import {digitsFaToEn} from 'persian-tools2';
import {useState, useRef, useEffect} from 'react';
import styled from 'styled-components';
const VerificationCodeInput = ({
  length,
  onComplete,
  setFieldValue,
  name,
  values,
}) => {
  const initialCode = values[name]?.length
    ? values[name]?.split('').slice(0, length)
    : Array(length).fill('');
  const [code, setCode] = useState(initialCode);
  const codeInputs = useRef([]);
  const [touchedIndex, setTouchedIndex] = useState(null);

  const handleChange = (event) => {
    let {value} = event.target;
    let index = code.findIndex((item) => item === '');
    // in this condition handle change call from handle key down and the value is empty
    if (value === '') {
      // index === -1 mean all the inputs are full,so we target last input the id 3
      if (index === -1) index = 3;
      else index = index - 1;
    } else {
      const output = value.split('').join(' ');
      value = [output[output.length - 1]];
    }
    if (value?.length === 1 || value === '') {
      setCode((prevCode) =>
        prevCode.map((char, i) => (i === index ? value : char))
      );
    }

    if (value !== '') {
      if (index < length - 1) {
        setTimeout(() => {
          codeInputs.current[index + 1].focus();
        }, 10);
      }
    }
  };

  const handleKeyDown = (event) => {
    let findIndex = code.findIndex((item) => item === '');
    if (findIndex === -1) findIndex = 4;
    codeInputs.current[findIndex - 1]?.setSelectionRange(0, 1);
    // if (event.key === 'Backspace' && findIndex > 0) {
    //   codeInputs.current[findIndex - 1].focus();
    // }

    if (event.key === 'Backspace' && findIndex > 0) {
      if (findIndex === length) {
        codeInputs.current[findIndex - 2].focus();
      } else {
        codeInputs.current[findIndex - 1].focus();
      }
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData
      .getData('text/plain')
      .slice(0, length);
    const parsedData = pastedData.replace(/\D/g, '').split('').slice(0, length);
    const newCode = parsedData.concat(
      Array(length - parsedData.length).fill('')
    );
    setCode(newCode);
  };

  useEffect(() => {
    if (onComplete) {
      onComplete(code.join(''));
    }
    setFieldValue(name, digitsFaToEn(code.join('')));
  }, [code]);

  return (
    <div dir='ltr'>
      <StyledInput>
        {code.map((char, index) => (
          <div key={index}>
            <input
              onInput={(e) => handleChange(e)}
              type='text'
              inputMode='numeric'
              pattern='[0-9]+'
              maxLength='1'
              autoFocus={index === 0}
              onFocus={() => setTouchedIndex(index)}
              onBlur={() => setTouchedIndex(null)}
              value={char}
              onPaste={handlePaste}
              // onChange={(e) => handleChange(e)}
              onKeyDown={(e) => handleKeyDown(e)}
              ref={(input) => (codeInputs.current[index] = input)}
            />
            <StyledSpan
              bgColor={code[index]}
              touched={index === touchedIndex}
            />
          </div>
        ))}
      </StyledInput>
    </div>
  );
};

export default VerificationCodeInput;

const StyledInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f5f5f5;
  border: ${({error}) =>
    error ? '  1px solid var(--red)' : '1px solid #ffffff;'};

  box-shadow: -4px -4px 15px #fff, 4px 4px 15px rgba(172, 172, 172, 0.5);
  border-radius: 16px;

  div {
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 5px 0;
  }

  input {
    width: 30px;
    text-align: center;
    margin: 10px 8px 11px;
    background: transparent;
    border: none;
    color: #753cbe;
    font-family: 'dana-bold';

    font-size: 18px;
    outline: none;
    padding: 0;
    caret-color: transparent;
  }
`;
const StyledSpan = styled.span`
  width: 80%;
  bottom: 16px;
  height: 1px;
  width: 30px;
  position: absolute;
  display: ${({bgColor, touched}) => (bgColor ? 'none' : 'visible')};
  background: ${({bgColor, touched}) => (bgColor ? '#753CBE' : '#753CBE')};
`;
